import { useApiPrivateRequest } from "../../../shared/hooks/useApi";
import { LlmClient } from "../models/LlmClient";

export const useUpdateLlmClient = () => {
  const {
    data: isUpdated,
    call,
    isLoading,
    isFailed,
  } = useApiPrivateRequest<boolean>((_) => true);

  const updateLlmClient = async (
    llmName: string,
    id: string,
    clientData: LlmClient,
  ) => {
    await call(
      `/admin/llm/${llmName}/clients/${id}`,
      "PUT",
      undefined,
      clientData,
    );
  };

  return {
    updateLlmClient,
    isUpdated,
    isLoading,
    isFailed,
  };
};
